export const focusToNextRow = (field: string, element: any): void => {
  const row = element.nativeElement.querySelector('[id="' + field + '"]');
  row.focus();
};
